module.exports = __webpack_public_path__ + "img/logo_yellow.ede50782.png";